import { render, staticRenderFns } from "./jiaocheng.vue?vue&type=template&id=7c561660&scoped=true&"
import script from "./jiaocheng.vue?vue&type=script&lang=js&"
export * from "./jiaocheng.vue?vue&type=script&lang=js&"
import style0 from "./jiaocheng.vue?vue&type=style&index=0&id=7c561660&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c561660",
  null
  
)

export default component.exports